// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"path":"/user/login","layout":false,"name":"登录","parentId":"1","id":"2"},"3":{"path":"/user","redirect":"/user/login","parentId":"1","id":"3"},"4":{"path":"/user/*","parentId":"1","id":"4"},"5":{"name":"BLOG","icon":"smile","path":"/wunz/:id","parentId":"max-tabs","id":"5"},"6":{"name":"404","icon":"smile","path":"/404","layout":false,"id":"6"},"7":{"path":"/","redirect":"/404","parentId":"max-tabs","id":"7"},"8":{"path":"/*","redirect":"/404","parentId":"max-tabs","id":"8"},"max-tabs":{"id":"max-tabs","path":"/","parentId":"ant-design-pro-layout","isLayout":true},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import('./EmptyRoute')),
'4': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__blog__index" */'@/pages/blog/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import('./EmptyRoute')),
'max-tabs': React.lazy(() => import(/* webpackChunkName: "t__plugin-maxtabs__Layout" */'/apps/data/homepage/src/.umi-production/plugin-maxtabs/Layout.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/apps/data/homepage/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
